// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"60e160d3","821":"a5b6ab90","977":"5fb0ddf7"}[chunkId] + ".chunk.js";
};